import { genericMemo } from "@redotech/react-util/component";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";

export const DateMatchKindSelect = genericMemo(function DateMatchKindSelect<
  DATE_COMPARISON_OPERATOR,
>({
  options,
  setMatchKind,
  selectedMatchKind,
}: {
  options: RedoListItem<DATE_COMPARISON_OPERATOR>[];
  setMatchKind: (matchKind: DATE_COMPARISON_OPERATOR) => void;
  selectedMatchKind: DATE_COMPARISON_OPERATOR | undefined;
}) {
  const { t } = useTranslation();
  return (
    <Flex align="center" dir="row" gap="md" wrap="wrap">
      <Text fontSize="xs" fontWeight="medium">
        {t("is")}
      </Text>
      <RedoSingleSelectDropdownInput<DATE_COMPARISON_OPERATOR>
        fitToAnchor={false}
        flexGrow={false}
        options={options}
        optionSelected={({ item }) => setMatchKind(item.value)}
        placeholder={t("Select a criteria")}
        selectedItem={options.find((o) => o.id === selectedMatchKind)}
        size="xs"
      />
    </Flex>
  );
});
